import { render, staticRenderFns } from "./NewStatusForm.vue?vue&type=template&id=516839cf&scoped=true&"
import script from "./NewStatusForm.vue?vue&type=script&lang=js&"
export * from "./NewStatusForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516839cf",
  null
  
)

export default component.exports